import * as React from 'react'
import {IExportElement} from '../../interfaces/reducers'
import {Editor} from 'react-draft-wysiwyg'
const draftToHtml = require('draftjs-to-html')
import htmlToDraft from 'html-to-draftjs'
import {EditorState, ContentState, convertToRaw} from 'draft-js'

interface Props {
  onOk: (elementProps: IExportElement) => void
  element: IExportElement
}

interface State {
  editorState: EditorState
}

export class ManagePrintText extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    const content = htmlToDraft(props.element.text || '')
    const editorState = EditorState.createWithContent(
      ContentState.createFromBlockArray(content.contentBlocks, content.entityMap)
    )
    this.state = {
      editorState
    }
  }

  onEditorStateChange = (editorState: EditorState) => {
    this.setState({
      editorState
    })
  }
  render() {
    return (
      <div style={{maxHeight: '600px', overflow: 'auto'}}>
        <Editor
          editorState={this.state.editorState}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
          toolbar={{
            options: [
              'inline',
              'fontSize',
              'fontFamily',
              'list',
              'textAlign',
              'colorPicker',
              'link',
              'embedded',
              'image',
              'remove',
              'history'
            ]
          }}
          onEditorStateChange={this.onEditorStateChange}
        />
        <button
          style={{marginBottom: '30px'}}
          className="button width"
          onClick={() => {
            let newText = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))
            newText = newText
              .replace(/font-family: Roboto[a-zA-Z,\-\s\"\d]+;/g, '')
              .replace(/background-color: rgb\([\d,]+\);/g, '')
            if (newText) {
              this.props.onOk({...this.props.element, text: newText})
            }
          }}
        >
          ОК
        </button>
      </div>
    )
  }
}
